import type { ButtonProps } from './types.js';
import { Icon } from '@studio/design-system/icon';
import { cn } from '@studio/design-system/motion';
import type { ReactElement } from 'react';

/** `<Button>` component. */
export const Button = ({
  disabled,
  label,
  labelSTag,
  settingsSTag,
  onSettings,
  onLabel,
  state
}: ButtonProps): ReactElement => {
  const isDisabled = !onLabel || disabled;
  return (
    <div
      className={cn('flex', 'rounded border bg-base-200 text-sm transition-colors', {
        'border-secondary': state !== 'in-progress',
        'border-error': state === 'in-progress'
      })}
    >
      <button
        type='button'
        {...labelSTag}
        disabled={isDisabled}
        onClick={onLabel}
        className={cn('transition-colors', 'px-8 h-28 flex items-center', {
          'text-muted hover:text-muted cursor-default': isDisabled,
          'text-error cursor-pointer hover:enabled:text-error hover:enabled:opacity-75':
            state === 'in-progress',
          'hover:text-foreground': !isDisabled
        })}
      >
        {label}
      </button>
      {onSettings && (
        <>
          <div className='h-28 border-l border-inherit' />
          <button
            type='button'
            {...settingsSTag}
            disabled={!onSettings}
            className={cn(
              'text-muted hover:text-foreground transition-colors',
              'h-28 pl-8 pr-10 flex items-center text-base'
            )}
            onClick={onSettings}
          >
            <Icon
              className={cn({
                'text-error': state === 'in-progress'
              })}
              icon='settings'
            />
          </button>
        </>
      )}
    </div>
  );
};
